// features/hive/ui/HiveTitle/HiveTitle.tsx
import {SharedHive} from "entities/hives/model/types";
import {HiveTitleRentTag, HiveTitleWrapper} from "features/hive/ui/HiveTitle/styles.ts";
import {FC} from "react";

export type HiveTitleProps = {
    number: number | null;
    nextHiveId: string | undefined;
    prevHiveId: string | undefined;
    findedShared :SharedHive | null;
};

export const HiveTitle: FC<HiveTitleProps> = ({ number, findedShared }) => {


    return (
        <HiveTitleWrapper>
            <h1>Улей №{number}</h1>
            {/* TODO: После готовности бекэнда под это вернуть переключение между ульями */}
            {/*<HiveArrowWrapper onClick={() => toHive(prevHiveId)}>*/}
            {/*    <ArrowRight/>*/}
            {/*</HiveArrowWrapper>*/}
            {/*<HiveArrowWrapper onClick={() => toHive(nextHiveId)}>*/}
            {/*    <ArrowRight/>*/}
            {/*</HiveArrowWrapper>*/}
            {Boolean(findedShared) && <HiveTitleRentTag>Аренда</HiveTitleRentTag>}
        </HiveTitleWrapper>
    );
};
